import React, { useState } from "react";
import { notification } from "../icon_assets";
import style from "./style.module.css";
import Notifications from "./Notification/Notification";
import OverThePageComponent from "../CommonComponents/OverThePageComponent.js/OverThePageComponent";
import HeadLines from "../CommonComponents/HeadLines";
import useUserDetails from "../CustomHooks/useUserDetails";
import EmailRegisterPopUp from "../Registration/EmailRegisterPopUp";
import EmailLinkSentPopUp from "../Registration/EmailLinkSentPopUp";

const Notification = ({ notifications = [] }) => {
  const [show, setShow] = useState(false);
  const userData = useUserDetails();
  const [showEmailVerifyPopUp, setShowEmailVerifyPopUp] = useState(false);
  const [showEmailSentPopUp, setShowEmailSentPopUp] = useState(false);
  const [email, setEmail] = useState("");
  const handleEmailVerifyPopUp = () => {
    const data = userData;
    setShow(false)
    setShowEmailVerifyPopUp(true);
    setEmail(data.email)
  }
  return (
    <>
      <div
        onClick={() => setShow(true)}
        className="positionRelative cursorPointer"
      >
        <HeadLines
          className={`positionAbsolute  ${style["notificationCSS"]} ${notifications?.length < 10
            ? style["width12"]
            : notifications?.length > 99
              ? style["width21"]
              : style["width16"]
            } font-size10 line-height12 letterSpacing025`}
          text={notifications?.length > 99 ? "99+" : notifications.length}
        />
        <img
          src={notification}
          alt=""
          className={`${style["IconHeightWidth"]}  margin-left16`}
        />
      </div>
      {show && (
        <OverThePageComponent show={show} setShow={setShow}>
          <Notifications setShow={setShow} notifications={notifications} handleEmailVerifyPopUp={handleEmailVerifyPopUp} />
        </OverThePageComponent>
      )}
      {showEmailVerifyPopUp && <EmailRegisterPopUp setShowEmailVerifyPopUp={setShowEmailVerifyPopUp} showEmailVerifyPopUp={showEmailVerifyPopUp} setEmail={setEmail} email={email} showVerifyEmailPopUSent={true} setShowEmailSentPopUp={setShowEmailSentPopUp}
        showEmailSentPopUp={showEmailSentPopUp} />}
      {showEmailSentPopUp && <EmailLinkSentPopUp
        setShowEmailSentPopUp={setShowEmailSentPopUp}
        showEmailSentPopUp={showEmailSentPopUp}
        email={email}
      />}
    </>
  );
};
export default Notification;
